var e={gap:{value:0},vertical:{alignItems:{value:"center"}},outer:{alignItems:{value:"center"}}};export{e as fieldgroup};
